import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: "anime",
    categoryName: "Anime Quiz",
    img: "570kioiF2jg",
  },
  {
    _id: "coding",
    categoryName: "Coding Quiz",
    img: "uCgoBZf9CDU",
  },
];
